import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import CardStack from './CardStack';
import HorizontalScroll from './HorizontalScroll';

class Main {
  constructor() {
    this.init();
  }

  init() {
    this.initSwiper();
    this.initCardStack();
    this.initHorizontalScroll();
  }

  initSwiper() {
    const swiper = new Swiper('.swiper', {
      modules: [Autoplay],
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }

  initCardStack() {
    const cardStack = new CardStack(document.querySelector('.card-stack'));
  }

  initHorizontalScroll() {
    const horizontalScroll = new HorizontalScroll(
      document.querySelector('.horizontal-scroll')
    );
  }
}

new Main();
